// Token transactions are provided with either .from or .to address properties based this logic:
// - First, try to decide based on whether the token amount transferred is positive or negative.
// - If the amount is zero, try to decide based on whether the token transfer array
//   contained only send or only receive type events.
// - Finally, if the value is zero and both receiving and sending transfer events
//   exist, consider the TX as sent if our wallet was the TX initiator.

export default function isConsideredSentTokenTx({
  coinAmount,
  ourWalletWasSender,
  sendingTransferPresent,
  receivingTransferPresent,
}) {
  if (coinAmount.isNegative) return true
  if (coinAmount.isPositive) return false

  // if the token TX's coinAmount is zero, the TX probably failed, so check
  // whether the failed transfers were solely out of, or solely in to ourWalletAddress
  if (sendingTransferPresent && !receivingTransferPresent) return true
  if (!sendingTransferPresent && receivingTransferPresent) return false

  // A rare edgecase which could only occur if somehow a token TX
  // transferred out exactly as much as our wallet received.
  return ourWalletWasSender
}
